<template>
  <div>
        <el-form :model="detailForm" label-width="105px" style="height:60vh;overflow-y:scroll;overflow-x:hidden;">
            <el-row :gutter="10">
                <el-col :span="8">
                    <el-form-item label="会议室名称">
                        <el-input disabled v-model="detailForm.name">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="租赁起期">
                        <el-input disabled v-model="detailForm.startTime">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="租赁止期">
                        <el-input disabled v-model="detailForm.endTime">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item label="选用服务">
                        <el-input disabled v-model="serviceConfigNames">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row :gutter="10">
                <el-col :span="8">
                    <el-form-item label="支付方式">
                        <el-input disabled v-model="payType">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="应付金额">
                        <el-input disabled v-model="detailForm.totalAmount">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="实付金额">
                        <el-input disabled v-model="detailForm.totalAmount">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row :gutter="10">
                <el-col :span="8">
                    <el-form-item label="条形码">
                        <el-input disabled v-model="detailForm.barCode">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>


            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item label="收款备注">
                        <el-input type="textarea" maxlength="50" v-model="detailForm.remark">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
      </el-form>
      
        <div slot="footer" class="dialog-footer" style="text-align:center;">
            <el-button @click="chargeConfirmAction" type="primary">确定</el-button>
            <el-button @click="$emit('detailClose',false)">关闭</el-button>
        </div>
  </div>
</template>

<script>
  import {pay} from "@/api/v4ward/stadium-management/charge";
export default {
    props:['detailForm'],
    data(){
        return{
            payType:'现金支付',
            serviceConfigNames:''
        }
    },
    created(){
        console.log(this.detailForm);
        let arr = [];
        this.detailForm.serviceConfig.forEach(element => {
            arr.push(element.name);
        });
        this.serviceConfigNames = arr.join(',');
    },
    methods:{
        chargeConfirmAction(){
            this.detailForm.payType = 1;
            this.detailForm.applyStatus = 5;
            this.detailForm.payAmount = this.detailForm.totalAmount;
            let self = this;
            this.detailForm.serviceConfig = '';
            pay(self.detailForm).then((res)=>{
                this.$message.success('操作成功！');
                this.$emit('detailClose',false);
            });
        },
    }
}
</script>

<style>

</style>